import TextOpenQuestion from 'models/common/form/question/open/TextOpenQuestion';

export default class TextOpenQuestionService {
	toModel(question) {
		return new TextOpenQuestion(question);
	}
}
